import LabServiceModel from "@/models/LabServiceModel";
import LaboratoryModel from "@/models/lab/LaboratoryModel";
import CustomerModel from "@/models/crm/CustomerModel";
import CustomerContactModel from "@/models/crm/CustomerContactModel";
import CustomerLocationModel from "@/models/crm/CustomerLocationModel";
import ProjectStatusLogCollection from "@/collections/lab/ProjectStatusLogCollection";
import SubmissionCollection from "@/collections/lab/SubmissionCollection";
import SampleCollection from "@/collections/lab/SampleCollection";

export default class ProjectModel extends LabServiceModel {
  modelName() {
    return "project";
  }
  icon() {
    return "shovel";
  }
  defaults() {
    return {
      id: null,
      pid: null,
      laboratory_id: null,
      laboratory: null,
      customer_id: null,
      customer: null,
      customer_location_id: null,
      customer_location: null,
      customer_contact_id: null,
      customer_contact: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      project_status_logs: [],
      current_project_status_log: null,
      submissions: []
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      pid: val => this.nullStringMutator(val),
      laboratory_id: val => this.nullStringMutator(val),
      customer_id: val => this.nullStringMutator(val),
      customer_location_id: val => this.nullStringMutator(val),
      customer_contact_id: val => this.nullStringMutator(val),
      invoice_id: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    };
  }
  validation() {
    return {};
  }
  routes() {
    const base = `${process.env.VUE_APP_LAB_REPOSITORY_URL}/api/v1/`;
    const routes = super.routes();

    routes.createSubmission = `${ base }${ this.modelName() }/{project_id}/submissions`;
    routes.validate = `${base}${this.modelName()}/validate`;
    routes.save = `${base}${this.modelName()}/save`;

    return routes;
  }
  createSubmission(payload) {
    const config = {
      method: this.getMethod("create"),
      url: this.getURL(this.getRoute("createSubmission"), {
        project_id: this.id
      }),
      data: payload
    };

    return this.createRequest(config).send();
  }
  save(payload) {
    const config = {
      method: this.getMethod("create"),
      url: this.getURL(this.getRoute("save")),
      data: payload
    };

    return this.createRequest(config).send();
  }
  validate(payload) {
    const config = {
      method: this.getMethod("create"),
      url: this.getURL(this.getRoute("validate")),
      data: payload
    };

    return this.createRequest(config).send();
  }
  getCustomer() {
    return this.getRelatedModel(CustomerModel, "customer");
  }
  getLaboratory() {
    return this.getRelatedModel(LaboratoryModel, "laboratory");
  }
  getCustomerContact() {
    return this.getRelatedModel(CustomerContactModel, "customer_contact");
  }
  getCustomerLocation() {
    return this.getRelatedModel(CustomerLocationModel, "customer_location");
  }
  getProjectStatusLogs() {
    return this.getRelatedCollection(
      new ProjectStatusLogCollection(),
      "project_status_logs"
    );
  }
  getSubmissions() {
    return this.getRelatedCollection(new SubmissionCollection(), "submissions");
  }
  getSamples() {
    const samples = new SampleCollection();

    this.getSubmissions().each(submission => {
      submission.getSamples().each(sample => {
        samples.add(sample);
      });
    });

    return samples;
  }
  publicNumber() {
    if (!this.get("pid")) {
      return null;
    }
    
    return this.get("pid").padStart(6, "0");
  }
}
